"use client";

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../UI/Button/Button";
import Input from "../UI/Input/Input";
import Label from "../UI/Label/Label";
import Card from "../UI/Card/Card";
import "./LoginPage.css";
import Cookies from "js-cookie";

function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [animateForm, setAnimateForm] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => {
      setAnimateForm(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const userData = {
        username: username,
        password: password,
      };
      const LOGIN_URL = "https://epic-emr-api.azurewebsites.net/login";

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(userData),
        redirect: "follow",
      };

      const response = await fetch(LOGIN_URL, requestOptions);
      const responseObj = await response.json();

      if (responseObj.status === "success") {
        // Set the JWT token in cookies
        Cookies.set("jwt_token", responseObj.auth_token, {
          expires: 1,
          path: "/",
        });

        // Navigate to home page after successful login
        navigate("/home");
      } else {
        setError(responseObj.message || "Login failed. Please try again.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("An error occurred during login. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className={`login-content ${animateForm ? "animate-in" : ""}`}>
        <Card className="login-card hover-lift hover-glow">
          <div className="login-header">
            <h2 className="login-title">LOGIN</h2>
            <p className="login-description">Sign in to your account</p>
          </div>
          <div className="login-body">
            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <Label htmlFor="username">Username</Label>
                <div className="input-wrapper">
                  <Input
                    id="username"
                    placeholder="Enter your username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    className="login-input"
                  />
                  <div className="input-icon username-icon"></div>
                </div>
              </div>

              <div className="form-group">
                <Label htmlFor="password">Password</Label>
                <div className="input-wrapper">
                  <Input
                    id="password"
                    type="password"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="login-input"
                  />
                  <div className="input-icon password-icon"></div>
                </div>
              </div>

              {error && (
                <div className="error-container scale-in">
                  <p className="error-message">{error}</p>
                </div>
              )}

              <Button
                type="submit"
                disabled={loading}
                className={`login-button ${loading ? "loading" : ""}`}
              >
                {loading ? (
                  <>
                    <span className="loading-spinner"></span>
                    <span>Signing in...</span>
                  </>
                ) : (
                  "Sign In"
                )}
              </Button>
            </form>
          </div>
          <div className="login-footer">
            <p className="login-hint">
              Enter your credentials to access the system
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default LoginPage;
